import axios from "axios";
import { error_handle } from "src/helpers/error";

export default class authen {
  
  logout(reason="Login again"){
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    window.location.href = '/#/login?log=' + reason
  }

  getUser() {
        return axios.request({
            url: '/authen/getUser',
            method: 'get',
        })

            .then(response => {
                response = response['data'];
                return response;
            })

            .catch((error) => {
                return {
                    result: false,
                    message: error.message
                }
            })

    }


    refreshToken(handleError = true) {
        if (window.isRefreshingToken) return Promise.resolve(false)
        window.isRefreshingToken = true
        return axios.request({
            url: '/authen/refreshToken',
            method: 'post',
            data: {
                refresh_token: window.localStorage.getItem('refreshToken'),
            }
        })

            .then(response => {
                window.isRefreshingToken = false
                response = response['data'];
                if (response['result']) {
                    let token = response['data']['token']
                    let refreshToken = response['data']['refreshToken']
                    window.localStorage.setItem('token', token)
                    window.localStorage.setItem('refreshToken', refreshToken)
                    this.updateSession()
                    return response['data']
                }else{
                    throw new Error(response['message'] || 'Login failed')
                }
                
            })

            .catch((error) => {
                window.isRefreshingToken = false
                handleError && error_handle(error)
                return false
            })

    }


    updateSession() {
        return axios.request({
            url: '/authen/updateSession',
            method: 'post',
        })

            .then(response => {
                response = response['data'];
                return response;
            })

            .catch((error) => {
                return {
                    result: false,
                    message: error.message
                }
            })

    }





    login(username, password, nextLink, captchaData, remember = true) {

        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', password);
        formData.append('remember', remember);
        formData.append('device_id', deviceId());
        if (captchaData) {
            formData.append('captcha', captchaData['captcha']);
            formData.append('captcha_hash', captchaData['hash']);
        }

        return axios.request({
            url: '/authen/login',
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })

            .then(response => {
                response = response['data'];
                if (response['result']) {
                    let token = response['data']['token']
                    let refreshToken = response['data']['refreshToken']
                    window.localStorage.setItem('token', token)
                    window.localStorage.setItem('refreshToken', refreshToken)
                    window.location.href = getLocalPath(nextLink)
                }else{
                    throw new Error(response['message'] || 'Login failed')
                }

                return true
            })

            .catch((error) => {
                console.log(error);
                return error;
            })

    }

    logout() {

        return axios.request({
            url: '/authen/logout',
            method: 'post'
        })

            .then(response => {
                response = response['data'];
                localStorage.removeItem('token')
                localStorage.removeItem('refreshToken')
                window.location.reload()
            })

            .catch((error) => {
                console.log(error);
                return error;
            })

    }
}
